import { render } from "./IdleWarning.vue?vue&type=template&id=37a95f36"
import script from "./IdleWarning.vue?vue&type=script&lang=js"
export * from "./IdleWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__